/** assets/scx-pc-filters-drawer.js */
(function () {
  var PC_MIN = 1025;

  var BODY_OPEN = 'scx-filters-open';
  var OVERLAY_CLASS = 'scx-filters-overlay';

  var PC_BAR_CLASS = 'scx-pc-filterbar';
  var PC_BTN_CLASS = 'scx-pc-filterbar__btn';

  var MOBILE_BAR_CLASS = 'scx-mobile-filterbar';

  var BEST_PAGE = '/collections/best-sellers';
  var NEW_PAGE = '/collections/new-arrivals';
  

  // Best Sellers（/collections/best-sellers）用这一组
  // 写法同 New：有 handle = 拉集合商品；没有 handle = 仍走 Shop by Need
  // handle = 后台集合地址 /collections/ 后面那段，例如 tops-clothing
  var DIRECT_BEST_FILTERS = [
    { label: 'Top Bras', handle: 'best-sellers-in-bras'},
    { label: 'Trending Swimwear', handle: 'best-sellers-in-swimwear'},
    { label: 'Best Shapewear', handle: 'shapewear-best-sellers'},
     { label: 'Most-Loved Underwear', handle: 'best-sellers-in-underwear'},
    { label: 'Everyday Clothing', handle: 'best-sellers-in-clothing' }
  ];

  // New Arrivals（/collections/new-arrivals）用这一组
  var DIRECT_NEW_FILTERS = [
    { label: 'New Bras', handle: 'new-arrivals-in-bras'},
    { label: 'Trending Shapewear', handle: 'best-sellers-in-swimwear'},
    { label: 'Best Underwear', handle: 'new-arrivals-in-underwear'},
    // { label: 'Featured Swimwear' handle: 'new-arrivals-in-bras'},
    { label: 'Top Clothing', handle: 'tops-clothing' }
  ];

  function isPC() {
    return window.innerWidth >= PC_MIN;
  }

  function isMobile() {
    return window.innerWidth < PC_MIN;
  }

  function currentPath() {
    return window.location.pathname.toLowerCase().replace(/\/$/, '');
  }

  function isBestPage() {
  return currentPath() === BEST_PAGE;
}

function isNewPage() {
  return currentPath() === NEW_PAGE;
}

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function norm(t) {
    return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function getSidebar() {
    return qs('#halo-sidebar[data-scx-drawer="filters"]') ||
      qs('#halo-sidebar') ||
      qs('.page-sidebar');
  }

  function getFacetBlocks() {
    var sidebar = getSidebar();
    if (!sidebar) return [];
    return qsa('.sidebarBlock.js-filter', sidebar);
  }

  function getFacetTitle(block) {
    var t =
      (qs('.sidebarBlock-heading .facets__label', block) && qs('.sidebarBlock-heading .facets__label', block).textContent) ||
      (qs('.sidebarBlock-heading span', block) && qs('.sidebarBlock-heading span', block).textContent) ||
      (qs('.sidebarBlock-heading', block) && qs('.sidebarBlock-heading', block).textContent) ||
      '';
    return String(t || '').replace(/\s+/g, ' ').trim();
  }

  function ensureOverlay() {
    var ov = qs('.' + OVERLAY_CLASS);
    if (ov) return ov;

    ov = document.createElement('div');
    ov.className = OVERLAY_CLASS;
    document.body.appendChild(ov);

    ov.addEventListener('click', function () {
      unlockKeepOpen();
      closeDrawer();
    });

    return ov;
  }

  function removeOverlay() {
    var ov = qs('.' + OVERLAY_CLASS);
    if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
  }

  function closeDrawer() {
    document.body.classList.remove(BODY_OPEN);
  }

  var keepOpen = false;
  var mo = null;

  function lockKeepOpen() {
    keepOpen = true;

    if (!mo) {
      mo = new MutationObserver(function () {
        if (!isPC()) return;
        if (!keepOpen) return;

        if (!document.body.classList.contains(BODY_OPEN)) {
          document.body.classList.add(BODY_OPEN);
        }
      });

      mo.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function unlockKeepOpen() {
    keepOpen = false;
  }

  function openDrawerBySCX() {
    ensureOverlay();
    lockKeepOpen();
    document.body.classList.add(BODY_OPEN);
  }

  function bindThemeCloseButtons() {
    document.addEventListener('click', function (e) {
      var hit = e.target.closest('.halo-sidebar-close, [data-close-sidebar], [data-close], .close, .icon-close');
      if (!hit) return;

      unlockKeepOpen();
      closeDrawer();
      cleanMobileSidebar();
    }, true);
  }

  function bindEsc() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        unlockKeepOpen();
        closeDrawer();
        cleanMobileSidebar();
      }
    });
  }

  function expandFacetByTitle(titleNorm) {
    var blocks = getFacetBlocks();
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var t = norm(getFacetTitle(block));
      var heading = qs('.sidebarBlock-heading', block);
      var content = qs('.sidebarBlock-contentWrapper', block);

      if (!heading) return;

      if (t === titleNorm) {
        heading.classList.add('is-clicked');
        heading.setAttribute('aria-expanded', 'true');

        if (content) {
          content.style.display = 'block';
          content.removeAttribute('hidden');
        }

        setTimeout(function () {
          try {
            heading.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
          } catch (e) {}
        }, 100);
      } else {
        heading.classList.remove('is-clicked');
        heading.setAttribute('aria-expanded', 'false');
        if (content) content.style.display = 'none';
      }
    });
  }

  function findToolbarHost() {
    return qs('#CollectionProductGrid .toolbar') ||
      qs('#CollectionProductGrid') ||
      qs('.collection-product-grid') ||
      document.body;
  }

  function ensurePCFilterBar() {
    if (!isPC()) return null;

    var host = findToolbarHost();
    if (!host) return null;

    var existing = qs('.' + PC_BAR_CLASS);
    if (existing) return existing;

    var bar = document.createElement('div');
    bar.className = PC_BAR_CLASS;

    var label = document.createElement('span');
    label.className = PC_BAR_CLASS + '__label';
    label.textContent = 'Filter By:';
    bar.appendChild(label);

    var btnWrap = document.createElement('div');
    btnWrap.className = PC_BAR_CLASS + '__btns';
    bar.appendChild(btnWrap);

    host.insertBefore(bar, host.firstChild);
    return bar;
  }

  function ensureBestSubNav() {
    if (!isBestPage() && !isNewPage()) return null;

    var host = findToolbarHost();
    if (!host) return null;

    var existing = qs('.scx-best-subnav');
    if (existing) return existing;

    var nav = document.createElement('div');
    nav.className = 'scx-best-subnav';

    var label = document.createElement('span');
    // label.className = 'scx-best-subnav__label';
    // label.textContent = 'Shop Best Sellers:';
    nav.appendChild(label);

    var list = document.createElement('div');
    list.className = 'scx-best-subnav__list';
    nav.appendChild(list);

    var toolbarItem =
      qs('toolbar-item.toolbar') ||
      qs('#CollectionProductGrid .toolbar') ||
      qs('.toolbar[data-toolbar]');

    if (toolbarItem && toolbarItem.parentNode) {
      toolbarItem.parentNode.insertBefore(nav, toolbarItem.nextSibling);
    } else {
      host.parentNode.insertBefore(nav, host);
    }

    return nav;
  }

  function removePCFilterBar() {
    qsa('.' + PC_BAR_CLASS).forEach(function (bar) {
      bar.remove();
    });
  }

  function findShopByNeedCheckbox(label) {
    var target = norm(label);
    var blocks = getFacetBlocks();

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var blockTitle = norm(getFacetTitle(block));

      if (blockTitle !== 'shop by need') continue;

      var inputs = qsa('input[type="checkbox"]', block);

      for (var j = 0; j < inputs.length; j++) {
        var input = inputs[j];

        var row =
          input.closest('li') ||
          input.closest('.facet-checkbox') ||
          input.closest('label') ||
          input.parentElement;

        if (!row) continue;

        var rowText = norm(row.innerText)
          .replace(/\[\d+\]/g, '')
          .replace(/\(\d+\)/g, '')
          .trim();

        if (rowText.indexOf(target) > -1) {
          return input;
        }
      }
    }

    return null;
  }

  function getItemLabel(item) {
    return typeof item === 'string' ? item : (item && item.label) || '';
  }

  function getItemHandle(item) {
    return typeof item === 'string' ? '' : (item && item.handle) || '';
  }

  function getSectionId() {
    var grid = qs('#main-collection-product-grid');
    if (grid && grid.dataset.id) return grid.dataset.id;

    try {
      return JSON.parse(sessionStorage.getItem('productGridId'));
    } catch (e) {
      return '';
    }
  }

  function clearActiveCollection() {
    window.scxActiveCollectionPath = '';
    window.scxActiveCollectionHandle = '';
  }

  function setActiveDirectBtn(activeBtn) {
    qsa('.scx-direct-filter-btn').forEach(function (el) {
      el.classList.toggle('is-active', el === activeBtn);
    });
  }

  function applyCollectionSectionHtml(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var sourceGrid = parsed.getElementById('CollectionProductGrid');

    if (!sourceGrid || !sourceGrid.querySelector('.collection')) {
      console.warn('[SCX] 集合页返回的 HTML 里没有商品网格，请核对 collection handle');
      return false;
    }

    if (typeof CollectionFiltersForm !== 'undefined') {
      CollectionFiltersForm.filterData = [];
      try {
        CollectionFiltersForm.renderFilters(html, null);
      } catch (err) {
        console.warn('[SCX] 更新侧边筛选失败', err);
      }
      CollectionFiltersForm.renderProductGrid(html);
      patchInfiniteLinksInGrid();
      return true;
    }

    var target = qs('#CollectionProductGrid .collection');
    if (!target) return false;
    target.innerHTML = sourceGrid.querySelector('.collection').innerHTML;
    document.body.classList.remove('has-halo-loader');
    patchInfiniteLinksInGrid();
    return true;
  }

  function loadCollectionByHandle(handle, btn) {
    var sectionId = getSectionId();
    var path = '/collections/' + handle;

    if (!sectionId) {
      console.warn('[SCX] 找不到 collection section id');
      if (btn) btn.dataset.scxBusy = '0';
      return;
    }

    window.scxActiveCollectionPath = path;
    window.scxActiveCollectionHandle = handle;
    document.body.classList.add('has-halo-loader');

    fetch(path + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        applyCollectionSectionHtml(html);
        setActiveDirectBtn(btn);
      })
      .catch(function (err) {
        console.warn('[SCX] 拉取集合失败：', handle, err);
        clearActiveCollection();
        setActiveDirectBtn(null);
      })
      .finally(function () {
        if (btn) btn.dataset.scxBusy = '0';
        document.body.classList.remove('has-halo-loader');
      });
  }

  function bindCollectionPagination() {
    if (document.documentElement.getAttribute('data-scx-collection-pager') === '1') return;
    document.documentElement.setAttribute('data-scx-collection-pager', '1');

    // 「显示更多 / infinite」交给主题原生逻辑追加商品。
    // 这里只拦截数字分页，避免整页跳到目标集合。
    document.addEventListener('click', function (e) {
      if (!window.scxActiveCollectionPath) return;

      var infiniteLink = e.target.closest('#CollectionProductGrid [data-infinite-scrolling]');
      if (infiniteLink) {
        // 确保 href 仍指向当前选中的集合，然后放行给 theme.js 做 append
        rewriteInfiniteLinkToActiveCollection(infiniteLink);
        return;
      }

      var link = e.target.closest('#CollectionProductGrid .pagination__list a');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      if (!href || href.indexOf('javascript:') === 0) return;

      e.preventDefault();
      e.stopPropagation();

      var sectionId = getSectionId();
      if (!sectionId) return;

      var query = '';
      try {
        query = new URL(href, window.location.origin).search.replace(/^\?/, '');
      } catch (err) {
        var qIndex = href.indexOf('?');
        query = qIndex >= 0 ? href.slice(qIndex + 1) : '';
      }

      document.body.classList.add('has-halo-loader');
      fetch(window.scxActiveCollectionPath + '?section_id=' + encodeURIComponent(sectionId) + (query ? '&' + query : ''))
        .then(function (response) { return response.text(); })
        .then(function (html) {
          applyCollectionSectionHtml(html);
        })
        .catch(function (err) {
          console.warn('[SCX] 集合分页失败', err);
        })
        .finally(function () {
          document.body.classList.remove('has-halo-loader');
        });
    }, true);
  }

  function rewriteInfiniteLinkToActiveCollection(link) {
    if (!window.scxActiveCollectionPath || !link) return;

    ['href', 'data-href'].forEach(function (attr) {
      var value = link.getAttribute(attr);
      if (!value || value.indexOf('javascript:') === 0) return;

      try {
        var url = new URL(value, window.location.href);
        var next = window.scxActiveCollectionPath + url.search + url.hash;
        link.setAttribute(attr, next);
      } catch (err) {}
    });
  }

  function patchInfiniteLinksInGrid() {
    if (!window.scxActiveCollectionPath) return;
    qsa('#CollectionProductGrid [data-infinite-scrolling]').forEach(rewriteInfiniteLinkToActiveCollection);
  }

  function makeDirectPCButton(item) {
    var label = getItemLabel(item);
    var handle = getItemHandle(item);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = PC_BTN_CLASS + ' scx-direct-filter-btn';
    btn.textContent = label;
    if (handle) btn.setAttribute('data-scx-collection-handle', handle);

    if (handle && window.scxActiveCollectionHandle === handle) {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.dataset.scxBusy === '1') return;
      btn.dataset.scxBusy = '1';

      if (handle) {
        loadCollectionByHandle(handle, btn);
        return;
      }

      clearActiveCollection();
      setActiveDirectBtn(btn);

      var targetCheckbox = findShopByNeedCheckbox(label);

      if (!targetCheckbox) {
        console.warn('[SCX] 找不到 Shop by Need 筛选项：', label);
        btn.dataset.scxBusy = '0';
        return;
      }

      var blocks = getFacetBlocks();

      blocks.forEach(function (block) {
        var blockTitle = norm(getFacetTitle(block));
        if (blockTitle !== 'shop by need') return;

        var inputs = qsa('input[type="checkbox"]', block);

        inputs.forEach(function (input) {
          if (input !== targetCheckbox && input.checked) {
            input.click();
          }
        });
      });

      setTimeout(function () {
        if (!targetCheckbox.checked) {
          targetCheckbox.click();
        }

        setTimeout(function () {
          btn.dataset.scxBusy = '0';
        }, 800);
      }, 120);
    });

    return btn;
  }

  function renderBestSubNavButtons(subList) {
  if (!subList) return;

  var items=[];

  if(isBestPage()){
      items=DIRECT_BEST_FILTERS;
  }

  if(isNewPage()){
      items=DIRECT_NEW_FILTERS;
  }

  if(!items.length) return;
  
    var nextKey = items.map(function (item) {
      return getItemLabel(item) + ':' + getItemHandle(item);
    }).join('|');

    if (subList.getAttribute('data-scx-render-key') === nextKey) {
      return;
    }

    subList.setAttribute('data-scx-render-key', nextKey);
    subList.innerHTML = '';

    items.forEach(function (item) {
      subList.appendChild(makeDirectPCButton(item));
    });
  }

  function rebuildPCButtons() {
    if (!isPC()) return;

    var bar = ensurePCFilterBar();
    if (!bar) return;

    var btnWrap = qs('.' + PC_BAR_CLASS + '__btns', bar);
    if (!btnWrap) return;

    var blocks = getFacetBlocks();
    if (!blocks.length) return;

    var titles = [];

    blocks.forEach(function (block) {
      var t = getFacetTitle(block);
      if (!t) return;

      var tn = norm(t);
      if (tn === 'refined by' || tn === 'refinedby') return;
      if (tn === 'shop by need') return;

      titles.push(t);
    });

    var seen = {};
    var uniq = [];

    titles.forEach(function (t) {
      var key = norm(t);
      if (seen[key]) return;
      seen[key] = true;
      uniq.push(t);
    });

    var btnKey = uniq.map(norm).join('|');
    if (btnWrap.getAttribute('data-scx-render-key') !== btnKey) {
      btnWrap.setAttribute('data-scx-render-key', btnKey);
      btnWrap.innerHTML = '';

      uniq.forEach(function (rawTitle) {
        var tNorm = norm(rawTitle);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = PC_BTN_CLASS;
        btn.setAttribute('data-scx-filter-title', tNorm);
        btn.textContent = rawTitle;

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          openDrawerBySCX();

          setTimeout(function () {
            expandFacetByTitle(tNorm);
          }, 80);
        });

        btnWrap.appendChild(btn);
      });
    }

    if (isBestPage() || isNewPage()) {
      var subNav = ensureBestSubNav();
      var subList = subNav ? subNav.querySelector('.scx-best-subnav__list') : null;
      renderBestSubNavButtons(subList);
    }
  }

  function openMobileSidebar() {
    var btn =
      qs('.toolbar-mobile .toolbar-sidebar[data-sidebar]') ||
      qs('.toolbar-wrapper.toolbar-mobile [data-sidebar]') ||
      qs('.toolbar-sidebar[data-sidebar]') ||
      qs('[data-sidebar]');

    if (btn) {
      btn.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
    }
  }

  function cleanMobileSidebar() {
    document.body.classList.remove(
      'open-mobile-sidebar',
      'has-sidebar',
      'halo-sidebar-open',
      'sidebar-open',
      'has-open-sidebar'
    );

    document.documentElement.classList.remove('open-mobile-sidebar');

    var sidebar = getSidebar();
    if (sidebar) {
      sidebar.classList.remove('is-open', 'active');
      sidebar.style.transform = '';
      sidebar.style.visibility = '';
      sidebar.style.opacity = '';
      sidebar.style.left = '';
    }
  }

  function ensureMobileBar() {
    qsa('.' + MOBILE_BAR_CLASS).forEach(function (el) {
      el.remove();
    });

    if (!isMobile()) return;
    if (!isBestPage() && !isNewPage()) return;

    var subNav = ensureBestSubNav();
    var subList = subNav ? subNav.querySelector('.scx-best-subnav__list') : null;

    renderBestSubNavButtons(subList);
  }

  function removeMobileBar() {
    qsa('.' + MOBILE_BAR_CLASS).forEach(function (el) {
      el.remove();
    });
  }

  var rebuildTimer = null;
  var isRebuildingScx = false;

  function scheduleRebuild() {
    if (isRebuildingScx) return;

    clearTimeout(rebuildTimer);

    rebuildTimer = setTimeout(function () {
      isRebuildingScx = true;

      if (isPC()) {
        rebuildPCButtons();
      } else {
        ensureMobileBar();
      }

      setTimeout(function () {
        isRebuildingScx = false;
      }, 350);
    }, 250);
  }

  var isInPCMode = null;

  function enterPCMode() {
    removeMobileBar();
    ensureOverlay();
    rebuildPCButtons();
  }

  function leavePCMode() {
    unlockKeepOpen();
    closeDrawer();
    removeOverlay();
    removePCFilterBar();
    ensureMobileBar();
  }

  function syncMode() {
    var nowPC = isPC();

    if (isInPCMode === null) {
      isInPCMode = nowPC;
      if (nowPC) enterPCMode();
      else leavePCMode();
      return;
    }

    if (nowPC === isInPCMode) return;

    isInPCMode = nowPC;

    if (nowPC) enterPCMode();
    else leavePCMode();
  }

  function boot() {
    bindEsc();
    bindThemeCloseButtons();
    bindCollectionPagination();

    syncMode();

    var grid = qs('#CollectionProductGrid') || qs('.collection-product-grid') || document.body;

    var ob = new MutationObserver(function () {
      scheduleRebuild();
    });

    ob.observe(grid, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', function () {
      syncMode();
      scheduleRebuild();
    });

    setTimeout(scheduleRebuild, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();